<template>
  <div class="order-step">
    <div class="two-col-res">
      <div>
        <div class="card">
          <div class="card-selection">
            <div
              class="list-container list-left list-header"
              :class="{ 'top-space': secure }"
            >
              <div class="list-header-holder" v-if="!secure">
                <div>
                  <spec-button
                    :title="'Bezorgen'"
                    :selected="deliver"
                    @action="setDeliver()"
                  ></spec-button>
                </div>
                <div>
                  <spec-button
                    :title="'Afhalen'"
                    :selected="pickUp"
                    @action="setPickup()"
                  ></spec-button>
                </div>
              </div>

              <address-list
                :currentAddress="address"
                :type="orderType"
                @setAddress="setAddress"
              ></address-list>
            </div>

            <div v-if="deliver" class="selection-main">
              <div class="title-container">
                <h3>Bezorgadres</h3>
                <div class="button-holder">
                  <button
                    class="white-pill-s"
                    v-if="addressesCount > 0 && custom.addresses.tempDelivery"
                    @click="editAddress('temp')"
                  >
                    Wijzigen
                  </button>

                  <button
                    class="white-pill-s"
                    @click="editAddress('edit')"
                    v-if="
                      address && !custom.addresses.editDelivery && address.id
                    "
                  >
                    Bewerken
                  </button>

                  <button
                    class="white-pill-s"
                    v-if="!custom.addresses.newDelivery"
                    @click="editAddress('new')"
                  >
                    Nieuw
                  </button>
                </div>
              </div>
              <div>
                <div class="address">
                  <p v-if="addressesCount == 0">
                    Uw adressenlijst is nog leeg<br />
                    <button
                      class="new-address pill-button"
                      @click="editAddress('new')"
                    >
                      Maak een bezorgadres aan
                    </button>
                  </p>
                  <p
                    class="error-text pointer"
                    v-else-if="!address.company && !address.id"
                    @click="editAddress('new')"
                  >
                    Uw bezorgadres ontbreekt of is nog niet compleet, klik hier.
                  </p>

                  <div v-else>
                    <p>{{ address.company }}</p>
                    <p
                      v-if="!address.department && custom.department.required"
                      class="error-text pointer"
                      @click="editAddress"
                    >
                      <span>Vul een </span>
                      <span
                        >{{
                          custom.department.label
                            ? custom.department.label
                            : 'Afdeling'
                        }}
                      </span>
                      <span>in, klik hier.</span>
                    </p>
                    <p v-else-if="address.department">
                      <span
                        >{{
                          custom.department.label
                            ? custom.department.label
                            : 'Afd. '
                        }}
                      </span>
                      <span>{{ address.department }}</span>
                    </p>
                    <div
                      class="custom-attention-of"
                      v-if="custom.addresses.customAttentionOf"
                    >
                      <label for="name">T.a.v.</label>
                      <input
                        class="grey-field"
                        type="text"
                        v-model="address.name"
                        id="name"
                      />
                    </div>
                    <p v-else-if="address.name">T.a.v. {{ address.name }}</p>
                    <p
                      class="error-text"
                      v-if="
                        custom.addresses.customAttentionOf &&
                        !address.name?.trim()
                      "
                    >
                      T.a.v. is verplicht.
                    </p>
                    <p>
                      {{ address.street }} {{ address.number }}
                      {{ address.addition }}
                    </p>
                    <p>{{ address.zipCode }} {{ address.city }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="pickUp" class="selection-main">
              <div class="list-header">
                <h3 class="title-container pickup-title">Afhaaladres</h3>
              </div>

              <div class="address">
                <p class="error-text" v-show="!address.company">
                  U heeft nog geen afhaaladres geselecteerd.
                </p>
                <p>{{ address.company }}</p>
                <p>
                  {{ address.street }} {{ address.number }}
                  {{ address.addition }}
                </p>
                <p>
                  {{ orderDetails.deliveryAddress.zipCode }}
                  {{ orderDetails.deliveryAddress.city }}
                </p>
                <p>{{ orderDetails.deliveryAddress.phone }}</p>
                <p>{{ orderDetails.deliveryAddress.email }}</p>
                <p v-show="address.company" class="times">
                  Geopend:<br />
                  maandag t/m vrijdag<br />
                  08:30 uur - 17:00 uur
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card card-front sub-card">
          <div class="card-default">
            <div class="top">
              <day-picker
                v-if="!printStoreOnly && !custom.hideDeliveryDates"
                :dates="dates"
                :active-date="date"
                @setDate="setDate"
                class="day-picker"
                :type="orderType"
                :combi-order="combiOrder"
              ></day-picker>
              <div class="ps-text ps-only" v-else-if="printStoreOnly">
                <p class="title">Bezorgmoment:</p>
                <span>
                  Binnen 3 werkdagen
                </span>
              </div>
            </div>
            <address-card :address="shop"></address-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DayPicker from '@/components/ui/DayPicker'
import AddressCard from '@/components/AddressCard'
import AddressSelectionList from '@/components/AddressSelectionList.vue'

import EditDeliveryAddress from '@/dialogs/EditDeliveryAddress.vue'
import SpecButton from '@/components/ui/SpecButton.vue'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import { useAddressBookStore } from '@/stores/AddressBook.store'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  props: ['orderDetails', 'shop', 'dates', 'secure'],
  data() {
    return {
      addresses: [],
      showInstr: false,
      newDeliveryAddress: {
        addition: '',
        city: '',
        company: '',
        deliveryAddress: true,
        department: '',
        id: 0,
        name: '',
        number: '',
        project: '',
        reference: '',
        street: '',
        zipCode: ''
      }
    }
  },
  mixins: [OrderMixin],
  components: {
    DayPicker,
    AddressList: AddressSelectionList,
    AddressCard,
    SpecButton,
    NextPrevMenu
  },
  methods: {
    updateOrder(key, val) {
      this.$emit('updateOrder', [key, val])
    },
    editAddress(type) {
      this.$modal.show(
        EditDeliveryAddress,
        {
          type: type,
          address: { ...this.address },
          callback: (model) => {
            this.setAddress(model)
          }
        },
        { width: 420, height: 'auto' }
      )
    },
    setDeliver() {
      this.updateOrder('orderType', 'deliver')
      const addressBook = useAddressBookStore()
      this.updateOrder(
        'deliveryAddress',
        addressBook.deliveryAddresses[0] || {}
      )
    },
    setPickup() {
      this.updateOrder('orderType', 'pickUp')
      this.updateOrder('deliveryAddress', {})
    },
    setAddress(address) {
      this.updateOrder('deliveryAddress', address)
    },
    setDate(date) {
      date.time = date.times[0].time || 'spoed'
      this.updateOrder('deliveryDate', date)
    },
    setShowInstr() {
      this.showInstr = true

      this.$nextTick(() => {
        this.$refs.instruction?.focus()
      })
    },
    updateLetter(val) {
      this.updateOrder('letter', val)
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    ...mapStores(usePrintStoreStore, useFileListStore),
    addressesCount() {
      const addressBook = useAddressBookStore()
      return addressBook.deliveryAddresses.length
    },
    address() {
      return this.orderDetails.deliveryAddress
    },
    letter() {
      return this.orderDetails.letter
    },
    date() {
      return this.orderDetails.deliveryDate
    },
    orderType() {
      return this.orderDetails.orderType
    },
    deliver() {
      return this.orderType === 'deliver'
    },
    pickUp() {
      return this.orderType === 'pickUp'
    },
    printStoreOnly() {
      return (
        this.printStoreStore.orderDetails.cart.length > 0 &&
        this.fileListStore.fileList.length === 0
      )
    },
    combiOrder() {
      return (
        this.printStoreStore.orderDetails.cart.length > 0 &&
        this.fileListStore.fileList.length > 0
      )
    },
    showInstructions() {
      if (!this.address.id) {
        return false
      } else if (!this.showInstr && this.letter.length < 1) {
        return false
      } else {
        return true
      }
    }
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.top-space {
  padding-top: 10px;
}
.pill-button {
  background-color: var(--arch-color);
}
.new-address {
  margin-top: 20px;
}
.top {
  flex-grow: 1;
}

.card {
  height: 590px;
}
.address {
  line-height: 1.5rem;
  min-height: 175px;
}

.times {
  margin-top: 14px;
}

.beg-schrijven-btn {
  margin-left: -6px;
}

.letter-text {
  height: 147px;
  width: 100%;
}

.ps-text {
  padding-top: 15px;

  box-shadow: var(--default-shadow);
  border-radius: 25px;
  padding: 20px;
  margin: -10px;

  .title {
    font-weight: 600;
  }

  span {
    list-style: normal;
  }
}

.title {
  font-weight: 500;
  padding-bottom: 5px;
}
.title-container.pickup-title {
  margin-bottom: 11px;
}

.custom-attention-of {
  line-height: 34px;
  margin: 6px 0;
  display: flex;
  width: 100%;

  label {
    font-weight: 300;
  }

  input {
    flex-grow: 1;
    max-width: 330px;
  }
}
</style>
